import * as React from 'react';

function Filter(){
    return(
            <div className='container-fluid mt-1 p-2'>
                <div className='col-lg-12 p-2 m-auto'>
                    <div className='row'>
               
                <div className='col-3'>
                    <div className='row'>
                    <div className='col-lg-2'>
                    <label>Date</label>
                   </div>
                   <div className='col-lg-9 ml-1'>
                   <input className='form-control form-control-sm'  type='date'></input>
                   </div>
                                     
                </div>
                </div>
                <div className='col-4'>
                    <div className='row'>
                    <div className='col-lg-3'>
                    <label>Department</label>
                   </div>
                   <div className='col-lg-7 ml-4'>
                    <select class="form-select form-select-sm" aria-label=".form-select-sm example">
                    <option selected>Select Department </option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                    </select>
                   </div>
                                     
                </div>
                </div>
                <div className='col-3'>
                    <div className='row'>
                    <div className='col-lg-2 pl-1'>
                    <label for="inlineFormDate">Assignee</label>
                   </div>
                   <div className='col-lg-9 ml-3 pl-4 '>
                    <select class="form-select form-select-sm" aria-label=".form-select-sm example">
                    <option selected>Select Assignee</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                    </select>
                   </div>
                                     
                </div>
                </div>
                <div className='col-lg-2'>
                <button type="button" class="btn btn-outline-danger  p-1 pl-2 pr-2 rounded-pill exportbtn">Export Default</button>
                </div>
                
                </div>
                
                </div>
                
                <hr className='goalsborder' ></hr>
            </div>
            
      
    );
}
export default Filter;